import { AuditUser, LoginResultTenant } from "."
import { UserStatus } from "./userStatus"
import { TenantFeatures } from "@/types/tenantFeatures"
import { LabeledValue } from "./labeledValue"
import { UserSettings } from "./userSettings"
import { EditDataPermission } from "./permission"
import { smeType } from "./sme"

interface BaseUser {
	id: string
	name: string
	email: string
	pictureUrl: string | null
	dbPicture: boolean
	disabled?: boolean
}

export default interface User extends BaseUser {
	tenantId: string
	teams: any[]
	userTeams?: any[]
	currentStatus?: UserStatus

	created?: Date
	createdBy?: AuditUser
	lastUpdated?: Date
	lastUpdatedBy?: AuditUser

	productionSME?: string[]
	reviewerSME?: string[]

	hasTimeManagement?: boolean
}

export interface UserWithFields extends User {
	fieldValues?: { [key:string]: LabeledValue },
	lastUpdateAcknowledged?: Date
}

export interface CurrentUser extends User {
	editData?: boolean
	editUsers?: boolean
	editInsights?: boolean
	isAdmin?: boolean;
	editDataPermissions?: EditDataPermission[] | null

	billingEnabled?: boolean

	recordName?: string
	caseName?: string

	tenantName: string
	isSupport: boolean

	quickCreateTemplates?: {
		id: string
		label: string
	}[];

	loginTenants?: LoginResultTenant[] | null

	extendedPermissions?: {
		[key: string]: boolean
	}

	enabledFeatures?: string[],
	tenantEnabledFeatures?: TenantFeatures[]
	tenantSize?: number;

	hasTenantInfo?: boolean
	hasDoneFirstLogin?: boolean
	hasViews?: boolean
	preferences?: UserPreferences
	settings?: UserSettings
	sessionValues?: { [key: string]: string }
	serverName? : string
}

export interface SystemUser extends BaseUser {
}

export interface AuthSetup {
	authCode: string | null,
	token: string | null
}

export interface AuthSubmit {
	authCode: string | null
}

export interface AccountDetails {
	mfaEnabled: boolean,
	isSuiteUser: boolean
}

export interface ExtendedPermission {
	key: string
    title: string
    description: string
	requiredFeature?: TenantFeatures | null
}

export enum ExtendedPermissions {
	EditSchedules = "scheduling",
	SetOtherUsersStatus = "setOtherUsersStatus",
	BulkDelete = "bulkDelete",
	EditUserSchedules = "editUserSchedules"
}

export interface UserIdWithStatus {
	userId: string
	userName?: string
	userStatus: UserStatus
	isExternal: boolean
}

export interface UserIdWithStatusAndFields extends UserIdWithStatus {
	userHeaderFieldValues: { [key: string]: LabeledValueWithFieldInfo }
}

export interface UserWithFieldInfo extends User {
	userHeaderFieldValues: { [key: string]: LabeledValueWithFieldInfo }
}

export interface LabeledValueWithFieldInfo extends LabeledValue {
	dataType: string
	fieldTitle: string
}

export interface UserPreferences {
	disableV2: boolean
	enableV2: boolean
}

export interface UserAdvancedSearch {
	smeTemplateId?: string
	smeType?: smeType
	nameFilter?: string
	userFieldSearches?: {
		userFieldId: string,
		values: string[]
	}[]
}
